import { Pipe, PipeTransform } from '@angular/core';
import { Shipment } from '../../models';
import { EOD_COMPLETED } from '../../../ngrx/status-types';

/**
 * Active Shipment pipe
 * Takes an array of shipments as an argument and filters out inactive shipments
 * e.g. Shipments with a status of "EOD Complete"
 *
 * Usage: shipments | activeShipment
 */

@Pipe({
  name: 'activeShipment'
})
export class ActiveShipmentPipe implements PipeTransform {
  transform(shipments: Shipment[]) {
    return shipments.filter(shipment => shipment.shipmentStatus !== EOD_COMPLETED);
  }
}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/pipes/active-shipment.pipe.ts